"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _style = _interopRequireDefault(require("./style.css"));
var _lab = _interopRequireDefault(require("./lab.svg"));
var _thumbnail = _interopRequireDefault(require("./thumbnail.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  name: 'Science Lab',
  className: _style["default"].background,
  assets: [_lab["default"]],
  imageUrl: _lab["default"],
  thumbnail: _thumbnail["default"]
};